module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@3x-f7f221bff5e60c839c7da180b288c6a7.png";